import { Controller } from "@hotwired/stimulus";

// Manages spot selection in the roster drawer.
// Click open spot → search panel reveals → autocomplete picks member → submit.
// The selected spot_id is injected into the autocomplete's extra_params
// so the server-rendered "Add" button includes it.
export default class extends Controller {
  static targets = ["spot", "searchPanel", "spotName"];
  static values = { bookUrl: String, frame: String };

  connect() {
    this.selectedSpotId = null;
  }

  selectSpot(e) {
    const btn = e.currentTarget;
    const spotId = btn.dataset.spotId;
    const label = btn.dataset.spotLabel;
    const color = btn.dataset.spotColor;

    this.selectedSpotId = spotId;

    // Highlight selected, dim others
    this.spotTargets.forEach((s) => {
      if (s.dataset.spotId === spotId) {
        s.style.boxShadow = `0 0 0 3px white, 0 0 0 5px ${color}`;
        s.style.borderStyle = "solid";
        s.style.opacity = "1";
      } else {
        s.style.boxShadow = "";
        s.style.borderStyle = "dashed";
        s.style.opacity = "0.4";
      }
    });

    // Show search, set label, focus input
    if (this.hasSearchPanelTarget) {
      this.searchPanelTarget.classList.remove("hidden");
      if (this.hasSpotNameTarget) this.spotNameTarget.textContent = label;

      const input = this.searchPanelTarget.querySelector("input[type=text]");
      if (input) {
        input.value = "";
        input.focus();
      }
    }

    this.syncSpotId(spotId);
  }

  deselect() {
    this.selectedSpotId = null;

    this.spotTargets.forEach((s) => {
      s.style.boxShadow = "";
      s.style.borderStyle = "dashed";
      s.style.opacity = "1";
    });

    if (this.hasSearchPanelTarget) {
      this.searchPanelTarget.classList.add("hidden");
    }

    this.syncSpotId(null);
  }

  // Inject spot_id into the autocomplete's extra_params JSON value
  // so the server receives it and includes it in the "Add" form.
  syncSpotId(spotId) {
    if (!this.hasSearchPanelTarget) return;

    const el = this.searchPanelTarget.querySelector(
      "[data-autocomplete-extra-params-value]"
    );
    if (!el) return;

    const params = JSON.parse(
      el.dataset.autocompleteExtraParamsValue || "{}"
    );

    if (spotId) {
      params.spot_id = spotId;
    } else {
      delete params.spot_id;
    }

    el.dataset.autocompleteExtraParamsValue = JSON.stringify(params);
  }
}
